// @flow
import { RESORT_BOOKING_BE } from 'Client/cms/toolkit/constants';
import { ProductBookingLine } from 'Components/lines/product-booking-line/ProductBookingLine';
import { productBookingBEResolver } from './productBookingBE.resolver';

export const productBookingBEDescriptor = {
  name: RESORT_BOOKING_BE,
  component: ProductBookingLine,
  resolve: productBookingBEResolver.resolve,
};
